<template>
  <div class="pageDiv">
    <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Schedule Admin</span>
      </v-card-title>
      Must login to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Schedule Admin</span>
      </v-card-title>

      <v-card-text style="margin: 7px 0">
        <div>
            <span class="label14">Select Year: </span>
            <select class="dropdown" v-model="year" @change="loadSchedule(year)">
              <option value="2025">2025</option>
              <option value="2024">2024</option>
            </select>
        </div>
      </v-card-text>

      <div style="height:20px"></div>

      <v-card>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                    color="#1867c0"
                    dark
                    v-bind="attrs"
                    v-on="on">
              Select Golf Course  <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
            </v-btn>
          </template>
          <v-list class="course-list" >
            <v-list-item
                    v-for="course in courses" :key="course">
              <v-list-item-title @click="createSchedule(course)">{{course.courseId}}-{{ course.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card>

      <v-card v-if="selectCourse!==null" class="course-card">

        <div class="course-item">
          <div>
            <span>Format: </span>
            <select class="dropdown" v-model="tournament.formatType">
              <option value="TOURNAMENT">TOURNAMENT</option>
              <option value="CUP">CUP</option>
              <option value="FUN">FUN</option>
              <option value="BANQUET">BANQUET</option>
            </select>
          </div>
          <div>
            <span>Sponsor: </span> <input class="okagaBtn" v-model="tournament.sponsorName"/>
          </div>
          <div>
            <span>Course Name: </span> {{selectCourse===null?'':selectCourse.name}}
          </div>
          <div>
            <span>Location: </span> {{selectCourse===null?'':selectCourse.location}}
          </div>
          <div>
            <span>Website: </span> {{selectCourse===null?'':selectCourse.website}}
          </div>
          <div>
            <span>Is a Major? </span> <input class="checkbox" type="checkbox" v-model="isMajor"/>
          </div>
          <div>
            <span>Is Shotgun? </span> <input class="checkbox" type="checkbox" v-model="isShotgun"/>
          </div>
          <div>
            <span>Is Single Match? </span> <input class="checkbox" type="checkbox" v-model="isSingleMatch"/>
          </div>
          <div>
            <span>Is Team Match? </span> <input class="checkbox" type="checkbox" v-model="isTeamMatch"/>
          </div>
        </div>

        <div class="course-item">
          <div>
            <span>Date Time: </span> <input type="datetime-local" class="okagaBtn" v-model="scheduleDate"/>
          </div>
          <div>
            <span>Early Ends: </span> <input type="datetime-local" class="okagaBtn" v-model="registrationDeadline"/>
          </div>
          <div>
            <span>Deadline: </span> <input type="datetime-local" class="okagaBtn" v-model="earlyRegisterDeadline"/>
          </div>
          <div>
            <span>Member Fee: $</span> <input class="okagaBtn" v-model="tournament.memberFee"/>
          </div>
          <div>
            <span>Guest Fee: $</span> <input class="okagaBtn" v-model="tournament.guestFee"/>
          </div>
          <div>
            <span>Junior Fee: $</span> <input class="okagaBtn" v-model="tournament.juniorFee"/>
          </div>
          <div>
            <span>Format: </span>
            <select class="dropdown" v-model="tournament.status">
              <option value="PLANNED">PLANNED</option>
              <option value="REGISTER">REGISTER</option>
            </select>
          </div>
          <div>
            <span>Limit: </span> <input class="okagaBtn" v-model="tournament.limitSize"/>
          </div>
        </div>

        <div style="display:inline-block;width:100%;">
          <v-btn class="add-button" @click="submitSchedule()">Add To Schedule</v-btn>
        </div>

      </v-card>

      <v-card class="schedule-card">
        <v-card-title><b>{{year}} Schedule</b></v-card-title>

        <div style="width: 100%; margin-bottom: 10px">
          <br>
          <input type="checkbox" style="width:25px;height:25px;" v-model="showClose" @change="loadSchedule(year)">
          <span class="label14" style="margin:0 0 0 7px;">
              Show Close Tournaments
          </span>
          <br>
        </div>

        <v-card class="tournament-card"
                v-for="schedule in schedules" :key="schedule">
          <div :class="{nonTournament: schedule.formatType !== 'TOURNAMENT'}">
            <div class="action-buttons">
              <v-btn class="btn-action" @click="removeSchedule(schedule.tournamentId)"><v-icon>mdi-delete</v-icon></v-btn>
              <v-btn class="btn-action" @click="editSchedule(schedule.tournamentId);"><v-icon>mdi-pencil</v-icon></v-btn>
            </div>

            <div class="course-item">
              <div>
                <span>Format: </span> {{schedule.formatType}} ({{schedule.tournamentId}})
              </div>
              <div>
                <span>Date: </span> {{printDate(Date.parse(schedule.scheduleDate))}}
              </div>
              <div>
                <span>Time: </span> {{printTime(Date.parse(schedule.scheduleDate))}} Shotgun
              </div>
              <div>
                <span>Early Ends:</span> {{printDateTime(Date.parse(schedule.earlyRegisterDeadline))}}
              </div>
              <div>
                <span>Deadline:</span> {{printDateTime(Date.parse(schedule.registrationDeadline))}}
              </div>
              <div>
                <span>Member Fee: </span> ${{schedule.memberFee}}
              </div>
              <div>
                <span>Guess Fee: </span> ${{schedule.guestFee}}
              </div>
              <div>
                <span>Junior Fee: </span> ${{schedule.juniorFee}}
              </div>
              <div>
                <span>19th Hole: </span> {{schedule.hole19}}
              </div>
            </div>

            <div class="course-item">
              <div>
                <span>Sponsor: </span> {{schedule.sponsorName}}
              </div>
              <div>
                <span>Course Name: </span> {{schedule.course.name}}
              </div>
              <div>
                <span>Location: </span> {{schedule.course.location}}
              </div>
              <div>
                <span>Website: </span> {{schedule.course.website}}
              </div>
              <div>
                <span>Is Major: </span> {{schedule.major==='Y' ? 'Yes' : 'No'}}
              </div>
              <div>
                <span>Is Shotgun Start: </span> {{schedule.shotgun==='Y' ? 'Yes' : 'No'}}
              </div>
              <div>
                <span>Is Single Match: </span> {{schedule.singleMatch ==='Y' ? 'Yes' : 'No'}}
              </div>
              <div>
                <span>Is Team Match: </span> {{schedule.teamMatch ==='Y' ? 'Yes' : 'No'}}
              </div>
              <div>
                <span>Status: </span> {{schedule.status}}
              </div>
              <div>
                <span>Limit: </span> {{schedule.limitSize}}
              </div>
            </div>
          </div>
        </v-card>
      </v-card>

    </v-card>

  </div>

</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';


  export default {
    name: "login",
    data: () => ({
      year: 2025,
      count: 0,
      isMajor: false,
      isShotgun: false,
      isSingleMatch: false,
      isTeamMatch: false,
      showPassword: false,
      schedules: {},
      courses: {},
      selectCourse: null,
      tournament: null,
      showClose: false,
      scheduleDate: moment().format('YYYY-MM-DDTHH:mm'),
      registrationDeadline: moment().format('YYYY-MM-DDTHH:mm'),
      earlyRegisterDeadline: moment().format('YYYY-MM-DDTHH:mm')
    }),
    mounted: function() {
        var _this = this;
        _this.initTournament();
        _this.loadSchedule(_this.year);
    },
    methods: {
      initTournament() {
        this.selectCourse = null;
        this.isMajor = false;
        this.isShotgun = false;
        this.isSingleMatch = false;
        this.isTeamMatch = false;

        this.tournament = {
          formatType: 'TOURNAMENT',
          active: 'N',
          shotgun: 'N',
          singleMatch: 'N',
          teamMatch: 'N',
          major: 'N',
          courseId: '',
          year: '',
          sponsorName: '',
          scheduleDate: '',
          memberFee: '',
          teeBox: '',
          limitSize: '0',
          courseYardage: '',
          nicklausCtp: '',
          palmerCtp: '',
          registrationDeadline: '',
          earlyRegisterDeadline: '',
          status: 'PLANNED',
          comment: '',
          file: null,
          sponsor: null,
          isBusy: false
        };
      },
      incrementCount: function() {
        this.count++;
        return this.count;
      },
      printDate(date) {
        return moment(date).format('ddd MMMM DD YYYY');
      },
      printTime(date) {
        return moment(date).format('hh:mm A');
      },
      printDateTime(date) {
        return moment(date).format('MMMM DD hh:mm A');
      },
      loadSchedule(inYear) {
          var _this = this;
          _this.axios.get('/public/courses')
          .then(function (response) {
              _this.courses = response.data;

              _this.axios.get('/admin/tournaments/year/'+inYear)
              .then(function (response) {
                  var scheds = response.data;
                  scheds.forEach(function(sched) {
                    for(var i=0; i < _this.courses.length; i++) {
                      if (sched.courseId === _this.courses[i].courseId) {
                        sched.course = _this.courses[i];
                      }
                    }
                    sched.edit = false;
                  });

                _this.schedules = new Array();
                for(var j=0; j < scheds.length; j++) {
                  if (scheds[j].status === 'CLOSE') {
                    if (_this.showClose) {
                      _this.schedules.push(scheds[j]);
                    }
                  }
                  else {
                    _this.schedules.push(scheds[j]);
                  }
                }

              })
              .catch(function (error) {
                  console.log('ERROR: ' + error);
              });

          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
      },
      createSchedule(course) {
        window.location.href = '/schedule-edit-admin?tournamentId=0&courseId=' + course.courseId;
      },
      editSchedule(tournamentId) {
          window.location.href = '/schedule-edit-admin?tournamentId=' + tournamentId;
      },
      removeSchedule(tournamentId) {
          var _this = this;

          swal({
            title: "Are you sure?",
            text: "Delete tournament ID " + tournamentId + "? You cannot recover!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                _this.axios.delete('/api/tournaments/' + tournamentId)
                .then(function (response) {
                    console.log('REMOVED Tournament Successful ' + response.data);
                    _this.loadSchedule(_this.year);
                })
                .catch(function (error) {
                    swal("Problem", "Cannot remove schedule because it has references.", "error");
                    console.log('ERROR: ' + error);
                });
            }
          });
      },
      getTime(dt) {
        return dt + ":00.000Z";
      },
      submitSchedule() {
        var _this = this;

        _this.tournament.scheduleDate = _this.getTime(_this.scheduleDate);
        _this.tournament.registrationDeadline = _this.getTime(_this.registrationDeadline);
        _this.tournament.earlyRegisterDeadline = _this.getTime(_this.earlyRegisterDeadline);
        _this.tournament.year = Number(moment(_this.scheduleDate).format('YYYY'));
        _this.tournament.courseId = _this.selectCourse.courseId;
        _this.tournament.active = 'Y';
        _this.tournament.shotgun = _this.isShotgun ? 'Y' : 'N';
        _this.tournament.major = _this.isMajor ? 'Y' : 'N';
        _this.tournament.singleMatch = _this.singleMatch ? 'Y' : 'N';
        _this.tournament.teamMatch = _this.teamMatch ? 'Y' : 'N';

        console.log(JSON.stringify(_this.tournament));

        _this.axios.post('/api/tournaments', _this.tournament)
        .then(function (response) {
            _this.selectCourse=null;
            _this.initTournament();
            _this.loadSchedule(_this.year);
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      }
    }
  }

</script>

<style scoped>
    .main-card {
        margin: 10px;
    }

    .course-list {
        padding: 10px;
        display: inline-block;
        overflow-y: scroll;
    }

    .table-card {
        height: 400px !important;
        padding: 10px;
        display: inline-block;
        overflow-y: scroll;
    }

    .member-table > tbody {
        height: 700px !important;
    }

    th {
        text-align: left;
        height: 28px;
        background-color: #45472e;
        border:1px solid aquamarine;
        box-shadow:2px 2px 1px -1px #000;
        font-size: 16px;
        color: aquamarine;
    }

    th, td {
        padding: 5px 10px;
    }

    td {
        font-size: 18px;
        color: #2a2b1e;
        border:1px solid rgba(0,0,0,0.4);
        box-shadow:-1px -1px 1px -1px #000;
    }

    input {
      width: 300px;
      height: 32px;
    }

    .course-card {
      padding: 20px;
      margin-top: 20px;
    }

    .course-item > div {
      display: inline-block;
      margin-bottom: 7px;
      width: 100% !important;
    }

    .course-item > div > span {
      display: inline-block;
      float: left;
      width: 120px;
      font-size: 14px;
      font-weight: bold;
    }

    .checkbox {
      display: inline-block;
      float: left;
      width: 20px;
      height: 20px;
    }

    .tournament-card {
      display: inline-block;
      background-color: #D6DADA !important;
      margin: 5px 0 !important;
      width: 100%;
      padding: 12px;
    }

    .course-item {
      display: inline-block;
      padding: 10px;
      height: auto;
      margin-bottom: 7px;
      vertical-align: top;
    }

    @media (min-width: 768px) {
        .v-card__text {

        }

        .member-table {
        }

        td {
          font-size: 14px !important;
        }

        .course-item {
          width: 500px !important;
        }
    }

    .nonTournament {
      background-color: lightgreen;
      padding: 10px;
    }
</style>